import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Rings } from 'react-loader-spinner';

export const useDebugMode = () => {
  const cartItems = useSelector(state => state.cart?.cartItems);
  const [isDebugMode, setIsDebugMode] = useState(false);

  useEffect(() => {

    const debugMode = cartItems?.entryQr === 'debug';
    setIsDebugMode(debugMode);

  }, [cartItems?.entryQr]);

  return { isDebugMode };
};

export const DebugModeProvider = ({ children }) => {
  const { isDebugMode } = useDebugMode();

  return (
    <>
      {children}

      {isDebugMode && (
        <div
          style={{
            position: 'fixed',
            top: '15%',
            right: '2px',
            zIndex: 9999,
            pointerEvents: 'none'
          }}
        >
          <Rings
            visible={true}
            height="40"
            width="40"
            color="#ff4444"
            ariaLabel="rings-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      )}
    </>
  );
};
